import { render, staticRenderFns } from "./MarketingAutomationHeader.vue?vue&type=template&id=2210e5c4&scoped=true"
import script from "./MarketingAutomationHeader.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationHeader.vue?vue&type=script&lang=js"
import style0 from "./MarketingAutomationHeader.vue?vue&type=style&index=0&id=2210e5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2210e5c4",
  null
  
)

export default component.exports